<template>
  <div class="container">
    <common-search-form-wrapper :reset="resetSearch">
      <el-form size="mini" ref="form" :model="searchInfo" label-width="64px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="授课教师:">
              <common-staff-pull-down
                :originId.sync="searchInfo.teacher_id"
                :defaultSelected.sync="searchInfo.teacher_list"
                :jobIds="[1]"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="上课时间:">
              <common-date-range-selector
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                v-model="searchInfo.lesson_date"
                @change="handleSearch"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="班级名称:">
              <el-select
                v-model.number="searchInfo.class_id"
                filterable
                clearable
                placeholder="请选择班级"
                @change="handleSearch"
                @focus="globalSearch('', 'class')"
                :filter-method="
                  (queryString) => {
                    globalSearch(queryString, 'class');
                  }
                "
              >
                <el-option
                  v-for="item in className"
                  :key="item.class_id"
                  :label="item.name"
                  :value="Number(item.class_id)"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="班级类型:" prop="course_type">
              <el-radio-group
                v-model="searchInfo.course_type"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="1">1vN</el-radio-button>
                <el-radio-button :label="2">1v1</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="排课课程:">
              <el-select
                v-model.number="searchInfo.course_id"
                filterable
                clearable
                placeholder="请选择课程"
                :filter-method="
                  (queryString) => {
                    globalSearch(queryString, 'course');
                  }
                "
                @focus="globalSearch('', 'course')"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in courseName"
                  :key="item.course_id"
                  :label="item.title"
                  :value="Number(item.course_id)"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="授课模式:" prop="lesson_type">
              <el-radio-group
                v-model="searchInfo.lesson_type"
                @change="handleSearch"
              >
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="2">线上</el-radio-button>
                <el-radio-button :label="1">线下</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="科目：">
              <el-select
                v-model="searchInfo.subject_ids"
                multiple
                filterable
                :filter-method="
                  (queryString) => {
                    globalSearch(queryString, 'subject');
                  }
                "
                @focus="globalSearch('', 'subject')"
                placeholder="请选择"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in subjectsList"
                  :key="item.subject_id"
                  :label="item.subject_title"
                  :value="item.subject_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="星期:">
              <el-select
                v-model="searchInfo.week_day"
                filterable
                placeholder="请选择"
                @change="handleSearch"
                clearable
              >
                <el-option
                  v-for="item in weekList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <div class="tip-box">
      <div class="tip-sm-box">推送提醒下课后未点名课次，完成点名后移除列表</div>
    </div>
    <div>
      <el-table
        v-horizontal-scroll
        size="mini"
        ref="mainTable"
        tooltip-effect="dark"
        style="width: 100%"
        :data="tableData"
        stripe
        @sort-change="clickSort"
      >
        <el-table-column label="授课教师" prop="teacher_list">
          <template slot-scope="scope">
            {{
              scope.row.teacher_list
                .map((item) => {
                  return item.name;
                })
                .join("、") || "-"
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="上课时间"
          width="250"
          prop="full_start_time"
          sortable="custom"
          :sort-orders="['ascending', 'descending']"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.date }}
              （周{{ scope.row.weekZh }}）
              {{ scope.row.start_time.slice(0, 5) }} ~
              {{ scope.row.end_time.slice(0, 5) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="班级名称" prop="class.name"> </el-table-column>
        <el-table-column label="班级类型" prop="course_type">
          <template slot-scope="scope">{{
            scope.row.class.course_type === 1 ? "1vN" : "1v1"
          }}</template>
        </el-table-column>
        <el-table-column label="排课课程" prop="course.title"></el-table-column>
        <el-table-column label="授课模式" prop="lesson_type">
          <template slot-scope="scope">
            <span v-if="scope.row.lesson_type == 1"> 线下 </span>
            <span v-if="scope.row.lesson_type == 2"> 线上 </span>
          </template>
        </el-table-column>
        <el-table-column
          label="上课内容"
          width="280"
          prop="class_lesson_extend.content"
          class-name="classCon"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.class_lesson_extend.content">
              {{ scope.row.class_lesson_extend.content }}
            </span>
            <span v-else> - </span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center">
          <template slot-scope="scope">
            <div class="operationBox">
              <lesson-dialog
                :lid="scope.row.lesson_id"
                style="display: inline-block; margin-right: 12px"
              >
                <div class="mwow-button primary">查看</div>
              </lesson-dialog>
              <div class="mwow-button success" @click="toRollCall(scope.row)">
                点名
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      v-if="loaded"
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      :style="{ float: 'right', padding: '17px' }"
    >
    </el-pagination>
  </div>
</template>
<script>
import { dateFormat } from "@/utils/timeFormat";
import {
  staffList,
  getSelectClassList,
  getSelectCourseList,
  autoSearchData,
  getSeleSubjectsList,
} from "@/api/globalSearch";
import lessonDialog from "@/view/teachManagement/storeSchedule/lessonDialog.vue";
import { noRollCallListApi } from "@/api/lesson";
import { PageModule } from "@/store/module/page";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

export default {
  props: ["visible"],
  name: "timeoutNotPointList",
  components: {
    lessonDialog,
    commonSearchFormWrapper,
    commonStaffPullDown,
    commonDateRangeSelector,
  },
  data() {
    return {
      searchInfo: {
        lesson_type: -1,
        course_type: -1,
        subject_ids: [],
        sort_field: "full_start_time",
        sort_type: "desc",
        teacher_id: "",
        teacher_list: [],
        lesson_date: [],
      }, //搜索数据
      tableData: [], //列表数据
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      staffName: "",
      courseName: "", //课程名字
      className: "", //班级名字
      teacherName: "",
      subjectsList: [],
      loaded: false,
      weekList: [
        {
          key: 1,
          value: "周一",
        },
        {
          key: 2,
          value: "周二",
        },
        {
          key: 3,
          value: "周三",
        },
        {
          key: 4,
          value: "周四",
        },
        {
          key: 5,
          value: "周五",
        },
        {
          key: 6,
          value: "周六",
        },
        {
          key: 0,
          value: "周日",
        },
      ],
    };
  },
  mounted() {
    if (PageModule.latestRoute === "classTimeDetails") {
      const cache = PageModule.pageInfo.timeoutNotPointList;
      if (cache.page) {
        this.page = cache.page;
      }
      if (cache.page_size) {
        this.pageSize = cache.page_size;
      }
      if (cache.search_info) {
        this.searchInfo = cache.search_info;
      }
    }
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.handleSearch();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.handleSearch();
    }
  },
  methods: {
    resetSearch() {
      this.searchInfo = {
        lesson_type: -1,
        course_type: -1,
        subject_ids: [],
        sort_field: "full_start_time",
        sort_type: "desc",
        teacher_id: "",
        teacher_list: [],
        lesson_date: [],
      };
      this.page = 1;
      this.pageSize = 10;
      this.rollCallList({
        page: 1,
        page_size: 10,
      });
    },
    getTime(e) {
      const weekZh = ["日", "一", "二", "三", "四", "五", "六"];
      const v = "（周" + weekZh[e.getDay()] + "）";
      const format = dateFormat("YYYY-mm-dd HH:MM", e);
      return format.slice(0, 10) + v + format.slice(11);
    },
    clickSort(e) {
      this.searchInfo.sort_field = e.prop;
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.rollCallList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    toRollCall(e) {
      PageModule.SET_PAGE_INFO({
        name: "timeoutNotPointList",
        key: "page",
        value: this.page,
      });
      PageModule.SET_PAGE_INFO({
        name: "timeoutNotPointList",
        key: "page_size",
        value: this.pageSize,
      });
      PageModule.SET_PAGE_INFO({
        name: "timeoutNotPointList",
        key: "search_info",
        value: this.searchInfo,
      });
      this.$router.push({
        name: "classTimeDetails",
        query: { id: e.lesson_id },
      });
    },
    getglobalsearchdata(data, type) {
      if (type == "staff") {
        return staffList(data);
      } else if (type == "teacher") {
        data.job_ids = [1];
        return staffList(data);
      } else if (type == "class") {
        return getSelectClassList(data);
      } else if (type == "course") {
        return getSelectCourseList(data);
      } else if (type == "subject") {
        return getSeleSubjectsList(data);
      }
    },
    async globalSearch(queryString, type) {
      const _t = this;
      let data = {
        page: 1,
        page_size: 100,
      };
      let restaurants = {};
      if (queryString) {
        data = {
          page: 1,
          page_size: 10,
        };
        if (type == "class") {
          data.name = queryString;
        } else if (type == "course") {
          data.title = queryString;
        } else {
          data.key_word = queryString;
        }
      }
      if (type == "subject") {
        data.page_size = 500;
      }
      restaurants = await _t.getglobalsearchdata(data, type);
      const list = restaurants.data.list;
      if (type == "staff") {
        _t.staffName = list;
      } else if (type == "teacher") {
        _t.teacherName = list;
      } else if (type == "class") {
        _t.className = list;
      } else if (type == "course") {
        _t.courseName = list;
      } else if (type == "subject") {
        _t.subjectsList = list;
      }
    },
    //上课记录
    rollCallList(data) {
      const _t = this;
      if (_t.searchInfo.sort_field) {
        data.sort_field = _t.searchInfo.sort_field;
      }
      if (_t.searchInfo.sort_type) {
        data.sort_type = _t.searchInfo.sort_type;
      }
      if (_t.searchInfo.class_id) {
        data.class_id = _t.searchInfo.class_id;
      }
      if (_t.searchInfo.lesson_date && _t.searchInfo.lesson_date.length === 2) {
        data.start_date = _t.searchInfo.lesson_date[0];
        data.end_date = _t.searchInfo.lesson_date[1];
      }
      if (_t.searchInfo.teacher_id) {
        data.teacher_id = _t.searchInfo.teacher_id;
      }
      if (_t.searchInfo.course_id) {
        data.course_id = _t.searchInfo.course_id;
      }
      if (_t.searchInfo.class_id) {
        data.class_id = _t.searchInfo.class_id;
      }
      if (_t.searchInfo.subject_ids && _t.searchInfo.subject_ids.length > 0) {
        data.subject_ids = _t.searchInfo.subject_ids;
      }
      if (_t.searchInfo.course_type > -1) {
        data.course_type = _t.searchInfo.course_type;
      }
      if (_t.searchInfo.lesson_type > -1) {
        data.lesson_type = _t.searchInfo.lesson_type;
      }
      if (_t.searchInfo.week_day === 0 || _t.searchInfo.week_day) {
        data.week_day = _t.searchInfo.week_day;
      } else {
        data.week_day = -1;
      }
      noRollCallListApi(data).then((res) => {
        if (res.error_code == 0) {
          res.data.list.map((item) => {
            const i = new Date(item.date.replace(/-/g, "/")).getDay();
            item.weekZh = ["日", "一", "二", "三", "四", "五", "六"][
              item.week_day
            ];
          });
          _t.tableData = res.data.list;
          _t.total = res.data.total;
          _t.page = res.data.page;
          if (!this.loaded) {
            this.loaded = true;
          }
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    handleSearch() {
      const _t = this;
      _t.rollCallList({
        page: 1,
        page_size: _t.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      const _t = this;
      _t.pageSize = e;
      _t.rollCallList({
        page: _t.page,
        page_size: _t.pageSize,
      });
    },
    handlePagerChange(e) {
      const _t = this;
      _t.page = e;
      _t.rollCallList({
        page: _t.page,
        page_size: _t.pageSize,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  position: relative;
}
.selfheader {
  display: flex;
  align-items: center;
}
.FoUpBtn {
  color: #409eff;
}
.editBtn {
  color: #07d1aa;
}
.closeBtn {
  color: #ffb940;
}
.delBtn {
  color: #5c5d5e;
}
.red {
  color: #f56c6c;
}
.green {
  color: #07d1aa;
}
.question {
  width: 15px;
  height: 15px;
  opacity: 1;
  background: #bebfc0;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  margin-left: 5px;
}
.orderChoose {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  .orderChooseSm {
    width: 40%;
    cursor: pointer;
    div {
      color: #5c5d5e;
      font-size: 14px;
      margin: 12px 0;
      text-align: center;
    }
    img {
      width: 100%;
      min-width: 140px;
      min-height: 94px;
    }
  }
}
.el-form .el-form-item__label {
  text-align: left !important;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 12px !important;
  margin-right: 80px !important;
}
//添加学员盒子
.drawer_box {
  padding: 0 5%;
}
.drawer_Head {
  font-size: 14px;
  color: #5c5d5e;
  margin-bottom: 14px;
}
.drawer_bottomBtn {
  display: flex;
  justify-content: flex-end;
  max-width: 380px;
  .reloadbtn {
    line-height: 22px;
    padding: 0;
    width: 44px;
    text-align: center;
  }
  .reloadbtn:nth-of-type(1) {
    margin-right: 10px;
  }
}
/deep/ .drawer_form {
  .drawer_chooseDate {
    background: #fff;
    .inputdate {
      width: 175px;
      .el-input__inner {
        border-radius: 4px 0 0 4px;
      }
    }
    .inputyear {
      width: 85px;
      height: 28px;
      display: inline-block;
      text-align: center;
      border-radius: 0 4px 4px 0px;
      border: 1px solid #dcdfe6;
      vertical-align: middle;
      margin-left: -1px;
      text-align: center;
    }
  }
  .drawer_input {
    width: 260px;
    .el-input-group__prepend {
      background: #fff;
    }
  }
  .drawer_onlychoose {
    .el-input {
      width: 260px;
    }
  }
  .drawer_selectchoose {
    .el-input {
      width: 80px;
    }
    .el-input__inner {
      padding-left: 6px;
    }
  }
}

/deep/ .drawerLenan_name {
  .el-form-item__label {
    line-height: 44px !important;
  }
}
/deep/ .avatar-uploader {
  .el-upload {
    border: 1px dashed #e7e8ea;
    border-radius: 50%;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 44px;
  height: 44px;
  line-height: 44px;
  text-align: center;
}
.avatar {
  width: 44px;
  height: 44px;
  display: block;
}
.tip-box {
  width: 100%;
  display: flex;
  justify-content: end;
  margin-bottom: 12px;
  .tip-sm-box {
    background: #fff7e9;
    height: 28px;
    width: 285px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #5c5d5e;
    border-radius: 4px;
  }
}
/deep/ .classCon {
  .cell {
    width: 23em;
    overflow: hidden; /*超出部分隐藏*/
    white-space: nowrap; /*禁止换行*/
    text-overflow: ellipsis;
  }
}
</style>
